import React, {useEffect, useState} from 'react'
import InitializationFeeEditModal from "./InitializationFeeEditModal"
import {getListTenantSubFee} from "../../../../../../services/api/apiCustomerHub"
import parseToken from "../../../../../../helpers/parseToken"
import {message, Spin} from "antd"
import {formatCurrency} from "../../../../../../helpers/convertArrayToObject"
import _checkRoles from "../../../../../../helpers/checkRole"

const InitializationFee = (props) => {
    const allowEdit = _checkRoles('menu.customerhub.editSubFee')
    const {custId} = props
    const decodeToken = parseToken()
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [listSubFee, setListSubFee] = useState([])
    const [selectItem, setSelectItem] = useState({})

    const _onOpenModal = () => {
        setIsOpen(true)
    }

    const _closeModal = () => {
        setIsOpen(false)
    }

    const _editSelectSubFee = (dataItem) => {
        _onOpenModal()
        setSelectItem(dataItem)
    }

    const _fetchListSubFee = async () => {
        setLoading(true)

        try {
            const response = await getListTenantSubFee(decodeToken.sub, custId)

            setLoading(false)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            setListSubFee(data)
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    useEffect(() => {
        _fetchListSubFee()
        // eslint-disable-next-line
    }, [])

    return (
        <div className="BlockCenter">
            <div className="headerBlock d-flex align-items-start justify-content-between">
                <h3>Giá khởi tạo/sub</h3>
            </div>
            <div className="ContentPage">
                <div className="CustomersTable">
                    <Spin spinning={loading} tip='Đang lấy dữ liệu...'>
                        <table>
                            <thead className="CustomersHead">
                            <tr>
                                <th>Telco</th>
                                <th>Loai</th>
                                <th>Phí</th>
                                <th>Mô tả</th>
                                <th className="Actions"/>
                            </tr>
                            </thead>
                            <tbody className="CustomersBody">
                            {
                                listSubFee.map(item => {
                                    return (
                                        <tr className="CustomersItem" key={item.id}>
                                            <td>{item.telco}</td>
                                            <td>{item.type}</td>
                                            <td>{formatCurrency(item.fee, 'en')}</td>
                                            <td>{item.description}</td>
                                            <td>
                                                {
                                                    allowEdit && <span
                                                        style={{fontSize: '18px'}}
                                                        className="material-icons cursor-pointer text-primary"
                                                        onClick={() => _editSelectSubFee(item)}
                                                    >border_color</span>
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </Spin>
                </div>
            </div>

            {isOpen && <InitializationFeeEditModal
                selectItem={selectItem}
                isOpen={isOpen}
                onClose={_closeModal}
                onGetAgain={_fetchListSubFee}
            />
            }
        </div>
    )
}

export default InitializationFee
